import api from './index';

export interface LoginResponse {
  access_token: string;
  token_type: string;
  username: string;
}

export interface UserInfo {
  id: number;
  username: string;
  created_at: string;
}

export const login = (username: string, password: string) =>
  api.post<LoginResponse>('/api/auth/login', { username, password });

export const register = (username: string, password: string) =>
  api.post<UserInfo>('/api/auth/register', { username, password });

export const getCurrentUser = () =>
  api.get<UserInfo>('/api/auth/me');

export const changePassword = (oldPassword: string, newPassword: string) =>
  api.post('/api/auth/change-password', {
    old_password: oldPassword,
    new_password: newPassword,
  });
